import React from 'react'
import { GuestListTableContainer } from '../owner/owner.style'
import {
  DetailsTabs,FlexyRow
} from  './property.style'
import About from './property-details/about';
import Transactions from './property-details/transactions';
import Debt from './property-details/debt';
import { useState } from 'react';
// import AccountSummary from './property-details/accountSummary';
import Dues from './property-details/dues';
import PropertyResident from './property-details/resident';
import Receivables from './property-details/receivables';

function PropertyDetailsPageWidget(props) {
  const data = props.data
  const pages =[
    {
      title:"About",
      widget:<About details={data} />
    },
    {
      title:"Transactions",
      widget:<Transactions  details={data} />
    },
    {
      title:"Dues",
      widget:<Dues details={data} />
    },
    {
      title:"Receivables",
      widget:<Receivables details={data} />
    },
    {
      title:"Debts",
      widget:<Debt details={data} />
    },
    // {
    //   title:"Account Summary",
    //   widget:<AccountSummary details={data} />
    // },
    {
      title:'Resident',
      widget:<PropertyResident  details={data} />
    }

  ];

const [selected,setSelected] = useState(0)
  return (
    <div>
        <GuestListTableContainer>

          <FlexyRow>
            {pages.map((itm,i)=>
              <DetailsTabs className=''
                onClick={()=>setSelected(i)}
              >
                <span className={selected===i?'active':''}>
                  {itm.title}
                </span>
              </DetailsTabs>
              )
            }
          </FlexyRow>
          <div className='' style={{
            padding:"8px"
          }}>
            {pages[selected].widget}   
          </div>
        </GuestListTableContainer>
    </div>
  )
}

export default PropertyDetailsPageWidget